import { User } from "@auth0/auth0-react";
import { useEffect } from "react";

interface PendoOptions {
  visitor?: Record<string, unknown>;
  account?: Record<string, unknown>;
}

export function usePendoSetup(options: PendoOptions) {
  const { visitor, account } = options;

  useEffect(() => {
    if (!visitor) {
      return;
    }

    if (!window.pendo) {
      console.error(
        "Pendo hasn't been initialized yet. Check the setup or add a timeout."
      );
      return;
    }

    if (window.pendo.isReady()) {
      window.pendo.updateOptions({
        visitor,
        account,
      });
    } else {
      window.pendo.initialize({
        visitor,
        account,
      });
    }
  }, [visitor, account]);
}

export function showPendoGuideById(guideId: string) {
  window.pendo?.showGuideById(guideId);
}

export function auth0UserToVisitor(user?: User) {
  return {
    id: user?.sub,
  };
}
